import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { RoutesList } from "@/router/routesList";
import { useGetCityByIdQuery, useUpdateCityMutation } from "@/store/api";
import { useSetPageData } from "@/tools/hooks";
import { CityEditForm } from "./components/CityEditForm";
import { convertToUpdateDto } from "./mappers";
export var CityEditPage = function () {
    var cityId = useParams().cityId;
    var cityGetState = useGetCityByIdQuery({ id: cityId });
    var _a = useUpdateCityMutation(), cityUpdateAction = _a[0], cityUpdateState = _a[1];
    var saveFormHandler = function (data) {
        try {
            cityUpdateAction({
                id: cityId,
                updateCityDto: convertToUpdateDto(data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var cancelFormHandler = function () {
        navigate(RoutesList.Manage.getCitiesList());
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (cityUpdateState.isSuccess) {
            navigate(RoutesList.Manage.getCitiesList());
        }
    }, [cityUpdateState.isSuccess]);
    useSetPageData({ title: "Город" });
    return (cityGetState.isSuccess && (_jsx(CityEditForm, { data: cityGetState.data, onSave: saveFormHandler, onCancel: cancelFormHandler })));
};
